import type { Project } from "@nlc/shared-types";

import { Banner } from "@/components/banner";
import { useShowBanners } from "@/features/requests/hooks/useShowBanners";

import type { BillingTabId } from "../../config/billing-tab-routes";

import { BILLING_TABS } from "../../config/billing-tab-routes";
import { PaymentBanners } from "./PaymentBanners";

interface BillingBannersProps {
  readonly project: Project;
  readonly tab: BillingTabId;
}

export function BillingBanners({ project, tab }: BillingBannersProps) {
  const accountStatusBanner = useShowBanners({ project, skipDunning: true });

  const isOverview = tab === BILLING_TABS.OVERVIEW;

  if (!isOverview && tab !== BILLING_TABS.PAYMENT_METHODS) return null;

  return (
    <div className="flex flex-col gap-lg px-xl pt-xl empty:hidden">
      <PaymentBanners placement="billing" projectId={project.id} />
      {isOverview && accountStatusBanner && (
        <Banner
          actions={accountStatusBanner.action}
          title={accountStatusBanner.title}
          variant="info"
        >
          {accountStatusBanner.message}
        </Banner>
      )}
    </div>
  );
}
